import React, { useState, useRef } from 'react';
import ReportTimePeriodDropDown from './ReportTimePeriodDropDown'
import ReportingProductsOptionDropdown from './ReportingProductsOptionDropdown'
import ToastAlert from '../ToastAlert';
import PropType from 'prop-types';

UserLeaderboardReportingFilters.propTypes = {
    setFilterState: PropType.func,
    filterState: PropType.object
}


function UserLeaderboardReportingFilters(props) {
    const {
        setFilterState,
        filterState
    } = props; 

    const [isTimeRangeMenuVisible, setIsTimeRangeMenuVisible] = useState(false);
    const [showToast, setShowToast] = useState(false);
    const [toastTitle, setToastTitle] = useState("");
    const [toastMessage, setToastMessage] = useState("");
    const timeRangeMenuRef = useRef(null);
	const timeRangeMenuContentRef = useRef(null);
    const [isProductsMenuVisible, setIsProductsMenuVisible] = useState(false);
    const productsMenuRef = useRef(null);
    const productsMenuContentRef = useRef(null);

    function closeOpenProductsMenus(event) {
		// click outside of menus and content menus = close menus
		if (
			productsMenuRef.current &&
			!productsMenuRef.current.contains(event.target) &&
			!productsMenuContentRef.current.contains(event.target) &&
			isProductsMenuVisible
		) {
			setIsProductsMenuVisible(false);
		}
	}
	document.addEventListener('mousedown', closeOpenProductsMenus);


    function closeOpenTimeRangeMenus(event) {
		// click outside of menus and content menus = close menus
		if (
			timeRangeMenuRef.current &&
			!timeRangeMenuRef.current.contains(event.target) &&
			!timeRangeMenuContentRef.current.contains(event.target) &&
			isTimeRangeMenuVisible
		) {
			setIsTimeRangeMenuVisible(false);
		}
	}
    document.addEventListener('mousedown', closeOpenTimeRangeMenus);

    function triggerToastAlert(title, message) {
        setToastTitle(title);
        setToastMessage(message);
        setShowToast(true);
    }

    return (
        <div className='d-flex flex-row'>    
         
            <ReportTimePeriodDropDown
                isEnabled={true}
                isMenuVisible = {isTimeRangeMenuVisible}
                menuContentRef={timeRangeMenuContentRef}
                menuRef={timeRangeMenuRef}
                setIsMenuVisible={setIsTimeRangeMenuVisible}
                filterState={filterState}
                setFilterState={setFilterState}
            ></ReportTimePeriodDropDown>
            <ReportingProductsOptionDropdown
                isEnabled={true}
                isMenuVisible = {isProductsMenuVisible}
                menuContentRef={productsMenuContentRef}
                menuRef={productsMenuRef}
                setIsMenuVisible={setIsProductsMenuVisible}
                filterState={filterState}
                setFilterState={setFilterState}
                triggerToastAlert={triggerToastAlert}
            ></ReportingProductsOptionDropdown>
            <ToastAlert
                show={showToast}
                setShow={setShowToast}
                title={toastTitle}
                message={toastMessage}
            />
        </div>
    );
}

export default UserLeaderboardReportingFilters;
